import * as React from 'react';
import {
  Box, Card, CardContent, createStyles, makeStyles, Typography,
} from '@material-ui/core';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

const useStyles = makeStyles(() => createStyles({
  root: {
    flexGrow: 1,
  },
  openerCard: {
    height: 180,
  },
  openerSvg: {
    height: 24,
    width: 24,
    marginBottom: 7,
  },
}));
interface CurrentBatchProps {
  carrier: string;
  count: number;
}

const CurrentBatch: React.FC<CurrentBatchProps> = (props) => {
  const classes = useStyles();
  const { carrier, count } = props;

  return (
    <Card className={classes.openerCard}>
      <CardContent>
        <LocalShippingIcon />
        <Typography gutterBottom>{carrier}</Typography>
        <Typography variant="h4" className="verticalCenter">
          <Box component="span" mr={1}>{count}</Box>
        </Typography>
        <Typography variant="caption" color="textSecondary">{'Boxes Scanned'}</Typography>
      </CardContent>
    </Card>
  );
};

export default CurrentBatch;
